import 'material-design-icons-iconfont/dist/material-design-icons.css' // Ensure you are using css-loader

import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'
import CloseIcon from '@/components/Icons/Close'
import CommentIcon from '@/components/Icons/Comment'
import DashboardIcon from '@/components/Icons/Dashboard'
import DeleteIcon from '@/components/Icons/Delete'
import DiscussionIcon from '@/components/Icons/Discussion'
import EditIcon from '@/components/Icons/Edit'
import HeartFilledIcon from '@/components/Icons/HeartFilled'
import HeartIcon from '@/components/Icons/Heart'
import InfoIcon from '@/components/Icons/Info'
import NotificationsIcon from '@/components/Icons/Notifications'
import ReplyIcon from '@/components/Icons/Reply'
import ResourceIcon from '@/components/Icons/Resource'
import SearchIcon from '@/components/Icons/Search'
import UserIcon from '@/components/Icons/User'
import UsersIcon from '@/components/Icons/Users'

Vue.use(Vuetify, {
  // iconfont: 'md',
  theme: {
    primary: '#0071BC', // amaze blue
    secondary: '#f8c822', // amaze yellow
    secondaryDark: '#ba961a', // amaze yellow dark
    accent: '#C93B3B', // amaze red
    error: '#FF5252', // flaming red for now
    info: '#2eb5cf', // amaze teal
    success: '#3bc93b', // flaming green for now
    warning: '#FFC107'
  },
  icons: {
    'amaze-close': {
      component: CloseIcon
    },
    'amaze-comment': {
      component: CommentIcon
    },
    'amaze-dashboard': {
      component: DashboardIcon
    },
    'amaze-delete': {
      component: DeleteIcon
    },
    'amaze-discussion': {
      component: DiscussionIcon
    },
    'amaze-edit': {
      component: EditIcon
    },
    'amaze-heart-filled': {
      component: HeartFilledIcon
    },
    'amaze-heart': {
      component: HeartIcon
    },
    'amaze-info': {
      component: InfoIcon
    },
    'amaze-notifications': {
      component: NotificationsIcon
    },
    'amaze-reply': {
      component: ReplyIcon
    },
    'amaze-resource': {
      component: ResourceIcon
    },
    'amaze-search': {
      component: SearchIcon
    },
    'amaze-user': {
      component: UserIcon
    },
    'amaze-users': {
      component: UsersIcon
    }
  }
})
